import { DateTime } from 'luxon';

/**
 * Checks if the deadline has passed
 * @param deadline - Date string in any format
 * @returns boolean indicating if deadline has passed
 */
const isDatePassed = (deadline: string): boolean => {
	const deadlineDate = DateTime.fromISO(deadline);

	// Trying to default parse
	if (!deadlineDate.isValid) {
		return DateTime.fromSQL(deadline) < DateTime.now();
	}

	return deadlineDate < DateTime.now();
};

export default isDatePassed;
